import template from "./template_crud";
import { all } from "./template_crud";
const inventory = '/inventory'
export const getInventory= template.getList(inventory)
export const getInventoryById = template.getById(inventory)

const equipment = '/inventory/equipment'
export const getInventoryEquipment= template.getList(equipment)
export const moveProject = {...all('/inventory/move/project')}
export const moveStorage = {...all('/inventory/move/storage')}